import { useControlledSubstanceGuidanceDrawer } from "client/controlledSubstances/stackables";
import { ControlledSubstanceClassification } from "client/controlledSubstances/types";
import { useFeatures } from "client/clinics/hooks";
import TextChip from "client/common/components/content/TextChip";
import TextButton from "client/common/components/buttons/TextButton";

import ProductLineReviews from "./ProductLineReviews";
import { IProductLineDetails } from "../types";

import styles from "../styles/ProductLineInfo.module.less";

type ProductLineInfoProps = {
  productLine: IProductLineDetails;
  controlledSubstanceClassification: ControlledSubstanceClassification | undefined;
  onReviewClick: () => void;
};

const ProductLineInfo = ({
  productLine,
  controlledSubstanceClassification,
  onReviewClick,
}: ProductLineInfoProps) => {
  const features = useFeatures();
  const isCarouselV2 = features.CAROUSEL_V2;
  const { open: openControlledSubstanceGuidanceDrawer } = useControlledSubstanceGuidanceDrawer();

  return (
    <div className={styles.container}>
      {(isCarouselV2 ? productLine.is_featured_v2 : !!productLine.featured_categories.length) && (
        <div className={styles.tags}>
          <TextChip variant="primary">
            {isCarouselV2 ? (
              "Your Vet's Choice"
            ) : (
              <>
                Your Vet&apos;s Choice for{" "}
                {productLine.featured_categories.map((c) => c.extended_name).join(",")}
              </>
            )}
          </TextChip>
        </div>
      )}
      <h1 className={styles.title}>{productLine.name}</h1>
      <ProductLineReviews.Widget productLine={productLine} onClick={onReviewClick} />
      {productLine.short_description && (
        <p className={styles.description}>{productLine.short_description}</p>
      )}
      {controlledSubstanceClassification?.is_controlled && (
        <TextChip variant="grey">
          <TextButton onClick={openControlledSubstanceGuidanceDrawer}>
            Controlled substance
          </TextButton>
        </TextChip>
      )}
    </div>
  );
};

export default ProductLineInfo;
